import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Mail, CheckCircle2, ArrowLeft } from "lucide-react";
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

const RegistrationSuccessPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [resent, setResent] = useState(false);

  const handleResend = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Bitte geben Sie Ihre E-Mail-Adresse ein");
      return;
    }
    
    setLoading(true);
    try {
      await api.post("/api/auth/resend-verification", { email });
      setResent(true);
      toast.success("Neue Bestätigungs-E-Mail wurde gesendet!");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Fehler beim Senden");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen login-bg flex items-center justify-center p-4" data-testid="registration-success-page">
      <div className="login-overlay absolute inset-0"></div>
      
      <Card className="w-full max-w-md relative z-10 shadow-xl border-0 animate-fadeIn">
        <CardHeader className="text-center pb-2">
          <img src="/vytech-logo.png" alt="VyWork" className="h-16 w-auto mx-auto mb-2" />
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="w-8 h-8 text-green-600" />
          </div>
          <CardTitle className="text-2xl font-bold">
            Registrierung erfolgreich!
          </CardTitle>
          <CardDescription className="text-muted-foreground">
            Bitte bestätigen Sie Ihre E-Mail-Adresse
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-blue-600 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-blue-900">
                  Prüfen Sie Ihren Posteingang
                </p>
                <p className="text-xs text-blue-700 mt-1">
                  Wir haben Ihnen eine E-Mail mit einem Bestätigungslink gesendet. 
                  Klicken Sie auf den Link, um Ihr Konto zu aktivieren.
                </p>
              </div>
            </div>
          </div>
          
          <div className="border-t pt-4">
            <p className="text-sm text-muted-foreground mb-3">
              Keine E-Mail erhalten? Fordern Sie eine neue an:
            </p>
            <form onSubmit={handleResend} className="space-y-3">
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input
                  type="email"
                  placeholder="Ihre E-Mail-Adresse"
                  className="pl-10"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <Button
                type="submit"
                variant="outline"
                className="w-full"
                disabled={loading || resent}
              >
                {loading ? "Wird gesendet..." : resent ? "E-Mail gesendet!" : "Neue E-Mail anfordern"}
              </Button>
            </form>
          </div>
          
          <Link to="/login" className="block">
            <Button variant="ghost" className="w-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Zum Login
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default RegistrationSuccessPage;
